import { queryeStudentEvaluationNote, queryStudentIPQ } from '@/api'
import { ImagePreview } from 'vant'
import F2 from '@antv/f2/lib/index-all'
export default {
  name: 'projectDetails-page',
  data () {
    return {
      currentRate: 0,
      value1: 3,
      queryData: {},
      courseInfo: {}, // 课程信息
      summary: {}, // 出勤概况
      progress: null, // 出勤概况
      teacher: [],
      teacher_noImage: [], // 各种老师说
      teacher_withImage: [], // 各种老师说
      composite: {}, // 综合评价
      image: [],
      comment: [],
      studentName: '',
      studentUrl: '',
      gradientColor: {
        '0%': '#7CBEFB',
        '100%': '#4982FF'
      },
      courseTypeId: null,
      evaluation: null,
      listColor: ['#80BFFF', '#FFD780', '#FF80AF', '#FFA780'],
      classTimeNumberTest: [],
      isTypeId: false,
      isIepq: false
    }
  },
  created () {
    this.getStudentEvaluationNote()
  },
  destroyed () { },
  methods: {
    getchart () {
      if (this.teacher_withImage && this.teacher_withImage.length) {
        this.teacher_withImage.forEach((item, index) => {
          if (item.score.length > 0 && (index !== 0 && index % 2 !== 0)) {
            // 雷达图
            const data = item.score || []
            data.forEach((item1) => {
              this.$set(item1, 'user', 'score')
              this.$set(item1, 'score', Number(item1.score))
              this.$set(item1, 'name', item1._scoreChooseList.find(item2 => Number(item2.score) === Number(item1.score)).name)
            })
            const chart = new F2.Chart({
              id: 'index' + index,
              pixelRatio: window.devicePixelRatio
            })
            chart.coord('polar', {
              radius: 1
            })
            chart.source(data, {
              score: {
                min: 0,
                max: 10,
                nice: true,
                tickCount: 3
              }
            })
            chart.axis('score', {
              label: function label (text, index, total) {
                return null
              },
              grid: function grid (text) {
                return {
                  lineDash: null,
                  type: 'arc', // 弧线网格
                  fill: 'rgba(232, 237, 240, 0.6)'
                }
              }
            })
            chart.area().position('title*score').color('user')
              .style({
                fill: '#4983FF'
              })
              .animate({
                appear: {
                  animation: 'groupWaveIn'
                }
              })
            chart.line().position('title*score').color('user')
              .style({
                fill: '#4983FF'
              })
              .animate({
                appear: {
                  animation: 'groupWaveIn'
                }
              })
            chart.point()
              .position('title*score')
              .shape('circle')
              .size(4)
              .style({
                stroke: '#fff',
                lineWidth: 1,
                fillOpacity: 1
              })
              .color('user')
            chart.axis('title', {
              field: null,
              line: null,
              tickLine: null,
              grid: {
                lineStyle: {
                  lineDash: null
                },
                hideFirstLine: true
              },
              label: (text, index) => { // 雷达图提示title文字
                let score = data[index].name
                let text1 = ''
                if (text.length > 19) {
                  text1 = `${text.slice(0, 18)}\n${text.slice(18, text.length)}`
                } else {
                  text1 = text
                }
                if (score.length > 13) {
                  score = `${score.slice(0, 16)}\n${score.slice(16, score.length)}`
                }
                return {
                  text: `${text1}\n( ${score} )`
                }
              }
            })
            chart.legend(false)
            chart.tooltip(false)
            chart.render()
          }
        })
      }
    },
    Leavingmessage () {
      this.$router.push({ path: '/leavingMessage' })
    },
    async getStudentEvaluationNote () {
      let sellOrderId = null
      let classId = null
      let weekStr = null
      let isCurrentClass = null
      let createStr = null
      console.log(this.$route)
      // if (this.$route.query.sellOrderId) {
      //   sellOrderId = this.$route.query.sellOrderId
      //   classId = this.$route.query.classId
      //   weekStr = this.$route.query.weekStr
      //   isCurrentClass = this.$route.query.isCurrentClass
      //   createStr = this.$route.query.createStr
      //   this.courseTypeId = this.$route.query.courseTypeId
      // } else {
      //   sellOrderId = this.getQueryString('sellOrderId')
      //   classId = this.getQueryString('classId')
      //   weekStr = this.getQueryString('weekStr')
      //   isCurrentClass = this.getQueryString('isCurrentClass')
      //   createStr = this.getQueryString('createStr')
      //   this.courseTypeId = this.getQueryString('courseType')
      // }
      sellOrderId = this.getQueryString('sellOrderId')
      classId = this.getQueryString('classId')
      weekStr = this.getQueryString('weekStr')
      isCurrentClass = this.getQueryString('isCurrentClass')
      createStr = this.getQueryString('createStr')
      this.courseTypeId = this.getQueryString('courseType')
      this.isIepq = this.courseTypeId && (Number(this.courseTypeId) === 30 || Number(this.courseTypeId) === 42 || Number(this.courseTypeId) === 48 || Number(this.courseTypeId) === 50)
      let result = {}
      if (this.isIepq) {
        result = await queryStudentIPQ({ sellOrderId: sellOrderId, classId: classId, weekStr: weekStr, isCurrentClass: isCurrentClass, createStr: createStr })
      } else {
        result = await queryeStudentEvaluationNote({ sellOrderId: sellOrderId, classId: classId, weekStr: weekStr, isCurrentClass: isCurrentClass, createStr: createStr })
      }
      this.queryData = result.data
      this.courseInfo = result.data.courseInfo
      this.summary = result.data.summary
      this.progress = result.data.progress
      this.teacher = result.data.teacher
      this.teacher_noImage = result.data.teacher_noImage
      this.teacher_withImage = result.data.teacher_withImage
      this.composite = result.data.composite
      this.evaluation = result.data.evaluation ? result.data.evaluation : null
      this.classTimeNumberTest = result.data.classTimeNumberTest ? result.data.classTimeNumberTest : null
      this.image = result.data.image
      this.isTypeId = this.courseInfo.courseType * 1 === 1// 学生端，加英文翻译
      // this.comment = result.data.comment ? result.data.comment : []
      if (this.image && this.image.length) {
        this.image.forEach(item => {
          this.$set(item, 'listcopy', JSON.parse(JSON.stringify(item.list)))
          item.list = this.groupList(item.list)
        })
      }
      this.$nextTick(() => {
        this.getchart()
      })
    },
    groupList (list) {
      const arr = []
      for (var i = 0; i < list.length; i += 2) {
        arr.push(list.slice(i, i + 2))
      }
      return arr
    },
    makeWeekStr (weekStr) {
      const list = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十']
      const list1 = ['Session One', 'Session Two', 'Session Three', 'Session Four', 'Session Five', 'Session Six', 'Session Seven', 'Session Eight', 'Session Nine', 'Session Ten', 'Session Eleven', 'Session Twelve', 'Session Thirteen', 'Session Fourteen', 'Session Fifteen', 'Session Sixteen', 'Session Seventeen', 'Session Eighteen', 'Session Nineteen', 'Session Twenty']
      const index = list.findIndex(item => weekStr === item)
      if (index !== -1 && this.isTypeId) {
        return `第${weekStr}节` + '\n' + list1[index]
      }
      return `第${weekStr}节`
    },
    getQueryString (name) {
      const url1 = window.location.search
      const url = decodeURI(url1)
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      const r = url.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      };
      return null
    },
    // 查看图片
    showbeforeimg (item) {
      ImagePreview({
        images: item,
        showIndex: false,
        closeOnPopstate: true,
        closeable: true
      })
    }
  }
}
